import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 400 400"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  style: {"fill":"none"},
  d: "M0 0h400v400H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M311.2 75H88.889A13.889 13.889 0 0 0 75 88.889v222.4A13.889 13.889 0 0 0 88.889 325h119.792v-96.684h-32.605v-37.83h32.466v-27.778c0-32.291 19.722-49.878 48.611-49.878a270.4 270.4 0 0 1 29.114 1.476v33.611h-19.948c-15.625 0-18.715 7.448-18.715 18.368v24.2h37.465l-4.861 37.83H247.6V325h63.6a13.888 13.888 0 0 0 13.8-13.8V88.889A13.889 13.889 0 0 0 311.2 75Z",
  style: {"fill":"#4267b2"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M247.6 325v-96.684h32.6l4.861-37.83H247.6v-24.114c0-10.921 3.038-18.369 18.715-18.369h19.862v-33.767a270.434 270.434 0 0 0-29.115-1.476c-28.8 0-48.524 17.587-48.524 49.879v27.778h-32.462v37.9h32.466V325Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }